import React, { Component } from 'react';
import { withRouter } from '../ganchos/withRouter';
import ApiService from '../service/ApiService';
import UtilService from '../service/UtilService';
import { Menubar } from 'primereact/menubar';
import IconeHay from "../images/heitortrevisangames.png";
import IconePix from "../images/pixheitor.png";
import { DataView } from 'primereact/dataview';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { Dialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';


class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    async componentDidMount() {
        const retorno = await ApiService.consultaProjetos();
        this.setState({ projetos: retorno.registros });
    }

    abrirNoScracth(projeto){
        window.open(projeto.arquivo, "blank");
    }

    async abrirJogo(projeto){
        const atualizarContador = await ApiService.atualizarContador(projeto);
        if (atualizarContador){
            projeto.contador = atualizarContador.contador;
        }        
        this.setState({ mostrarJogar: true, projeto: projeto });
    }


    templateDataView(itens) {
        return itens.map((it,index) => {
            return (
                <div className="col-12" key={it.id} style={{ backgroundColor: "#fe7a01"}}>
                    <div className={classNames('flex flex-column xl:flex-row xl:align-items-start p-4 gap-4', { 'border-top-1 surface-border': index !== 0 })}>
                        <img onClick={()=> this.setState({ mostrarJogar: true, projeto: it })} className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round cursor-pointer" src={ApiService.urlBase + it.imagem} alt={it.name} />
                        <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                            <div className="flex flex-column align-items-center sm:align-items-start gap-3">
                                <div className="text-2xl font-bold " style={{ color: "#FFF"}}>{it.nome}</div>
                                <div className="flex align-items-center gap-3">
                                    <span className="flex align-items-center gap-2"  style={{ color: "#FFF"}}>
                                        <i className="pi pi-tag"></i>
                                        <span className="font-semibold">{it.descricao}</span>
                                    </span>
                                </div>
                            </div>
                            <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                                <div class="gap-2 flex ">
                                    <Button tooltip="Quantidade de vezes que este jogo foi visualizado" icon="pi pi-eye" className="custom-target-icon p-button-rounded"  style={Object.assign({backgroundColor: "rgb(187 91 4)", borderColor: "rgb(187 91 4)", whiteSpace: "nowrap"})} tooltipOptions={{ position: 'left' }}>&nbsp;{it.contador || 0}</Button>
                                    <Button tooltip="Clique para jogar este jogo!" icon="pi pi-play" className="p-button-rounded" onClick={()=> this.abrirJogo(it)} disabled={it.inventoryStatus === 'OUTOFSTOCK'} style={{backgroundColor: "rgb(187 91 4)", borderColor: "rgb(187 91 4)"}}>&nbsp;Jogar</Button>
                                </div>
                                <div class="gap-2 w-full">
                                    <Button icon="pi pi-link" tooltip="Abrir o projeto externamente" className="p-button-rounded w-full text-center" onClick={()=> this.abrirNoScracth(it) } disabled={it.inventoryStatus === 'OUTOFSTOCK'} style={Object.assign({backgroundColor: "rgb(187 91 4)", borderColor: "rgb(187 91 4)", whiteSpace: "nowrap"}, UtilService.reactShow(it.tipoarquivo == "main.projeto.tipoarquivo.scratch"))} tooltipOptions={{ position: 'left' }}>&nbsp;Ver no Scracth</Button>
                                    <Button icon="pi pi-bolt" className="p-button-rounded w-full text-center" disabled={true} style={Object.assign({backgroundColor: "rgb(187 91 4)", borderColor: "rgb(187 91 4)", whiteSpace: "nowrap"}, UtilService.reactShow(it.tipoarquivo == "main.projeto.tipoarquivo.html"))}>&nbsp;Feito com HTML</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    }

    processarSrcIframe(){
        if (this.state.projeto?.tipoarquivo == "main.projeto.tipoarquivo.scratch"){
            return this.state.projeto?.arquivo + "embed?autoplay=true";
        } else {
            return ApiService.urlBase + this.state.projeto?.arquivo;
        }
    }
    

    render() {
        const listTemplate = (items) => {
            if (!items || items.length === 0) return null;

            let list = items.map((product, index) => {
                return this.itemTemplate(product, index);
            });

            return <div className="grid grid-nogutter">{list}</div>; 
        };

        const start = <div className="quadrante-menu-superior md:pl-8 md:ml-8 flex flex-row">
            <img className="flex-shrink-1 mr-2" alt="logo" src={IconeHay} height="40"></img>
            <p className="flex-1 m-1 p-2" style={{ color: '#FFF' }}>Heitor Trevisan Games</p>
        </div>

        const end = <div className="quadrante-menu-superior md:pr-8 md:mr-8 flex flex-row">
            <a onClick={ ()=> this.setState({mostrarPix: true}) } className="flex-1 m-1 p-2 cursor-pointer" style={{ color: '#FFF' }}>Pague uma Esfirra <i className="pi pi-thumbs-up-fill"></i></a>
        </div>
        return (
            <>
                <Tooltip target=".custom-target-icon" />
                <div className="card menu-superior" style={{ backgroundColor: "#fe7a01" }}>
                    <Menubar start={start} end={end}  />
                    <DataView value={this.state.projetos} listTemplate={(items) => this.templateDataView(items)} className="md:mx-8 md:p-8" style={{ backgroundColor: "#fe7a01"}} />
                </div>
                <Dialog header={"Jogar " + this.state.projeto?.nome } visible={this.state.mostrarJogar} className={"w-10 md:w-5"} onHide={() =>  this.setState({ mostrarJogar: false })}>
                    <p className="m-0 text-center">
                       <iframe allowtransparency="true" allowfullscreen="" frameborder="0" style={{ width: "100%", aspectRatio: "16/9", minHeight: 300, height: 500 }} src={this.processarSrcIframe()} width="100%"  scrolling="no" ></iframe>
                    </p>
                </Dialog>

                <Dialog header="Obrigado pelo seu apoio" visible={this.state.mostrarPix} style={{ width: '40vw' }} onHide={() => { this.setState({ mostrarPix: false })}}>
                    <p>
                        Criei este site com minhas próprias ideias, projetos e muita curiosidade.
                        Cada jogo que você vê aqui nasceu de testes, erros, aprendizado e,
                        principalmente, vontade de criar algo divertido para outras pessoas jogarem.
                    </p>

                    <p>
                        Se você gostou de algum jogo, se divertiu por alguns minutos ou simplesmente
                        achou legal ver alguém tão novo criando seus próprios projetos, você pode me
                        apoiar de um jeito simples: fazendo um <strong>PIX</strong>.
                    </p>

                    <p>
                        Esse apoio não é obrigatório, mas faz toda a diferença. Com ele, posso
                        comemorar meu esforço comprando algo que eu gosto muito, como uma caixa de
                        esfirras do <strong>Habib’s</strong> ou um milkshake do
                        <strong> Madero</strong> 🍔🥤. Parece simples, mas para mim é uma forma de
                        reconhecimento e incentivo para continuar aprendendo, criando e melhorando
                        meus jogos.
                    </p>

                    <p>
                        Cada PIX é como dizer:<br/>
                        <em>“continue, você está no caminho certo”</em>.
                    </p>

                    <p>
                        E isso vale mais do que qualquer prêmio.
                    </p>

                    <p>
                        Obrigado por jogar, por visitar meu site e por apoiar meus projetos ❤️ Abaixo está o QR Code para fazer o PIX:
                    </p>
                    <div className>
                        <img src={IconePix} style={{ width: "50%" }} />
                    </div>
                    
                </Dialog>
            </>
        )
    }
}
export default withRouter(Dashboard);